import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { usePageStore } from '@/shared/store/page';

export function AppShell(): JSX.Element {
  const title = usePageStore((s) => s.title);
  const subtitle = usePageStore((s) => s.subtitle);
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  // Cierra el drawer móvil al navegar.
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-bg">
      <div className="print:hidden">
        <Sidebar mobileOpen={navOpen} onClose={() => setNavOpen(false)} />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="print:hidden">
          <Topbar title={title} subtitle={subtitle} onMenuClick={() => setNavOpen(true)} />
        </div>
        <main className="flex-1 p-4 sm:p-6 lg:p-7 print:p-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
